import { render, staticRenderFns } from "./iva.vue?vue&type=template&id=660a3cce&lang=html&"
import script from "./iva.vue?vue&type=script&lang=js&"
export * from "./iva.vue?vue&type=script&lang=js&"
import style0 from "./iva.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports